module.exports = __webpack_public_path__ + "static/media/external-link.65080ff9.svg";